export default "__VITE_ASSET__UTCoBOpF__"